import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions, PAGE_PERMISSION_IDS } from '../hooks/usePermissions';
import { useTheme } from '../context/ThemeContext';
import logo from '../assets/images/logo.png';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { canView, isAdmin } = usePermissions();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navStyle = {
    backgroundColor: 'var(--navbar-bg)',
    padding: '1rem 0',
    color: 'white',
    width: '100%',
    transition: 'background-color 0.3s ease',
  };

  const navContainerStyle = {
    width: '100%',
    padding: '0 40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  return (
    <nav style={navStyle}>
      <div className="nav-container" style={navContainerStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          {/* Логотип в начале */}
          <img 
            src={logo} 
            alt="Логотип компании" 
            style={{
              height: '40px',
              width: 'auto',
              objectFit: 'contain',
              marginRight: '20px',
              borderRight: '1px solid rgba(255, 255, 255, 0.3)',
              paddingRight: '20px'
            }}
          />
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            {canView(PAGE_PERMISSION_IDS.dashboard) && <Link to="/" className="nav-link">Главная</Link>}
            {canView(PAGE_PERMISSION_IDS.directive) && <Link to="/directive-schedule" className="nav-link">Директивный график</Link>}
            {canView(PAGE_PERMISSION_IDS.hr) && <Link to="/hr-schedule" className="nav-link">HR-график</Link>}
            {canView(PAGE_PERMISSION_IDS.procurement) && <Link to="/procurement-schedule" data-testid="nav-procurement" className="nav-link">График закупок</Link>}
            {canView(PAGE_PERMISSION_IDS.construction) && <Link to="/construction-schedule" className="nav-link">График строительства</Link>}
            {canView(PAGE_PERMISSION_IDS.marketing) && <Link to="/marketing-schedule" className="nav-link">График маркетинга</Link>}
            {canView(PAGE_PERMISSION_IDS.preconstruction) && <Link to="/preconstruction-schedule" className="nav-link">График ТЗ</Link>}
            {canView(PAGE_PERMISSION_IDS.feedback) && (
              <Link to="/feedback" className="nav-link" style={{ color: '#38bdf8', fontWeight: 500 }}>💬 Обратная связь</Link>
            )}
            {canView(PAGE_PERMISSION_IDS.project_office) && <Link to="/project-office" className="nav-link">Проектный офис</Link>}
            {canView(PAGE_PERMISSION_IDS.strategic_map) && <Link to="/strategic-map" data-testid="nav-strategic-map" className="nav-link" style={{ color: '#a78bfa', fontWeight: 500 }}>📊 Мастер-карта</Link>}
            {canView(PAGE_PERMISSION_IDS.interactive_map) && (
              <a
                href={process.env.REACT_APP_INTERACTIVE_MAP_URL || 'http://localhost:3001'}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-interactive-map"
                className="nav-link"
                style={{ color: '#34d399', fontWeight: 500 }}
              >
                Интерактивная карта
              </a>
            )}
            {canView(PAGE_PERMISSION_IDS.process) && <Link to="/process-management" className="nav-link" style={{ color: '#fbbf24', fontWeight: 500 }}>📋 Процесс управления</Link>}
            {canView(PAGE_PERMISSION_IDS.dependencies) && <Link to="/dependency-manager" className="nav-link" style={{ color: '#f97316', fontWeight: 500 }}>🔗 Зависимости</Link>}
            {canView(PAGE_PERMISSION_IDS.cities) && <Link to="/cities" className="nav-link">Объекты строительства</Link>}
            {canView(PAGE_PERMISSION_IDS.stages) && <Link to="/construction-stages" className="nav-link">Этапы строительства</Link>}
            {isAdmin && <Link to="/telegram-settings" className="nav-link">Настройки Telegram</Link>}
            {isAdmin && <Link to="/admin" data-testid="nav-admin" className="nav-link" style={{ color: '#f87171', fontWeight: 600 }}>👑 Админ-панель</Link>}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {/* Переключатель темы */}
          <button
            type="button"
            data-testid="theme-toggle"
            onClick={toggleTheme}
            title={isDark ? 'Светлая тема' : 'Тёмная тема'}
            style={{
              background: 'none',
              border: '2px solid rgba(255,255,255,0.3)',
              borderRadius: '20px',
              padding: '6px 12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: 'white',
              fontSize: '14px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
            }}
          >
            <span style={{ fontSize: '18px' }}>{isDark ? '☀️' : '🌙'}</span>
            <span>{isDark ? 'Светлая' : 'Тёмная'}</span>
          </button>
          
          <span style={{ marginRight: '10px', opacity: 0.9 }}>
            👤 {user?.username} ({user?.role})
          </span>
          <button onClick={handleLogout} className="btn btn-secondary glass-btn glass-btn--sm">
            Выйти
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
